import { defineChain } from 'viem';

// Monad Mainnet Configuration
// Reference: https://docs.monad.xyz/developer-essentials/network-information
export const monad = defineChain({
    id: 143, // Chain ID from docs
    name: 'Monad',
    nativeCurrency: {
        name: 'MON',
        symbol: 'MON',
        decimals: 18,
    },
    rpcUrls: {
        default: {
            http: ['https://rpc.monad.xyz'],
            webSocket: ['wss://rpc.monad.xyz'],
        },
        public: {
            http: ['https://rpc.monad.xyz', 'https://rpc1.monad.xyz', 'https://rpc2.monad.xyz'],
            webSocket: ['wss://rpc.monad.xyz', 'wss://rpc1.monad.xyz'],
        },
    },
    blockExplorers: {
        default: {
            name: 'MonadScan',
            url: 'https://monadscan.com',
        },
        monadVision: {
            name: 'MonadVision',
            url: 'https://monadvision.com',
        },
        socialScan: {
            name: 'SocialScan',
            url: 'https://monad.socialscan.io',
        },
    },
    contracts: {},
});

export const SUPPORTED_CHAINS = [monad] as const;

